import type { ISINLookupRequest, ISINLookupResult } from "@repo/shared/types";
import { post } from "./_client";

export async function lookupISINs(isins: string[]): Promise<ISINLookupResult[]> {
  return post<ISINLookupResult[]>("/internal/openfigi/lookup", {
    isins,
  } satisfies ISINLookupRequest);
}
